import { Form, Input, Select, Icon } from 'ant-design-vue'
import MobileInput from './App'
import Storage from 'vue-ls'

MobileInput.install = (Vue) => {
  Vue.use(Form)
  Vue.use(Input)
  Vue.use(Select)
  Vue.use(Icon)
  Vue.use(Storage)
  Vue.component(MobileInput.name, MobileInput)
}

export default MobileInput
